/* eslint no-console: 1 */
import Axios from 'axios'
import baseService from './baseService'

const userService = {
	async authenticateLogin(pUsername: any, pPassword: any) {
		const config: any = baseService.generateConfigData()
		config.auth = {
			username: pUsername,
			password: pPassword
		}
		try {
			return await Axios.post(`${import.meta.env.VITE_APP_API_URL}auth/login`, {}, config)
		} catch (error) {
			//console.log(error)
			return ''
		}
	},
	async authenticateTotp(token: any, code: any, mode: any) {
		const config: any = baseService.generateConfigData()
		const data = {
			code: code,
			token: token,
			mode: mode
		}
		try {
			return await Axios.post(`${import.meta.env.VITE_APP_API_URL}auth/login2fa`, data, config)
		} catch (error) {
			//console.log(error)
			return ''
		}
	},
	async requestTOTPCode(userID: any, code: string, enable_2fa_totp: boolean) {
		const config = baseService.generateConfigData()
		const data = {
			code: code,
			user_key: userID,
			enable_2fa: enable_2fa_totp
		}
		try {
			return await Axios.post(
				`${import.meta.env.VITE_APP_API_URL}auth/verify2fa_totp`,
				data,
				config
			)
		} catch (error) {
			//console.log(error)
			return ''
		}
	},
	async requestSMSCode(userID: any) {
		const config = baseService.generateConfigData()
		const data = {
			user_key: userID
		}
		try {
			return await Axios.post(`${import.meta.env.VITE_APP_API_URL}auth/verify2fa_sms`, data, config)
		} catch (error) {
			//console.log(error)
			return ''
		}
	},
	async requestEmailCode(userID: any) {
		const config = baseService.generateConfigData()
		const data = {
			user_key: userID
		}
		try {
			return await Axios.post(
				`${import.meta.env.VITE_APP_API_URL}auth/verify2fa_email`,
				data,
				config
			)
		} catch (error) {
			//console.log(error)
			return ''
		}
	},
	async forgotPassword(email: string) {
		const payload = {
			email: email
		}
		try {
			return await Axios.post(
				`${import.meta.env.VITE_APP_API_URL}auth/forgotpassword`,
				payload,
				baseService.generateConfigData()
			)
		} catch (error) {
			return ''
		}
	},
	async resetPassword(token: any, password: string) {
		const payload = {
			token: token,
			new_password: password
		}
		try {
			return await Axios.post(
				`${import.meta.env.VITE_APP_API_URL}auth/forgotpassword/reset`,
				payload,
				baseService.generateConfigData()
			)
		} catch (error) {
			return error
		}
	},
	async getActivationQR(token: any) {
		const payload = {
			token: token
		}
		try {
			return await Axios.post(
				`${import.meta.env.VITE_APP_API_URL}auth/activate/qr`,
				payload,
				baseService.generateConfigData()
			)
		} catch (error) {
			return error
		}
	},
	activate(
		activationToken: any,
		password: string,
		enable_2fa_sms: boolean,
		enable_2fa_email: boolean,
		enable_2fa_totp: boolean,
		totp_code: string
	) {
		return Axios.post(
			`${import.meta.env.VITE_APP_API_URL}auth/activate`,
			{
				activationToken,
				password,
				enable_2fa_sms,
				enable_2fa_email,
				enable_2fa_totp,
				code: totp_code
			},
			baseService.generateConfigData()
		)
	},
	update2fa(password: string, login_token: any, totp_enabled: boolean) {
		return Axios.post(
			`${import.meta.env.VITE_APP_API_URL}auth/update2fa`,
			{
				token: login_token,
				password,
				totp_enabled
			},
			baseService.generateConfigData()
		)
	}
}

export default userService
